export default "__VITE_ASSET__CCklnewO__"